<template>
    <q-layout-footer>
        <q-toolbar class="mobile-hide bg-primary" style="padding: 0px; min-height: 30px;">
            <q-toolbar-title class="text-center text-weight-light">
                <small>Copyright © {{ (new Date()).getFullYear() }}: {{ getProjectName }} v{{ getVersion }} - Powered by <a href="https://take5.com.br" class="text-white">Take 5 LMS</a></small>
            </q-toolbar-title>
        </q-toolbar>
    </q-layout-footer>
</template>

<script>
export default {
    i18nOptions: { namespaces: [ "custom", "common", "admin"] },

    computed: {
        getProjectName() {
            return process.env.PROJECT_NAME
        },

        getVersion() {
            return process.env.APP_VERSION
        }
    }
}
</script>

<style lang="stylus" scoped>
@import '~variables'

ul
    list-style-type none
    margin 0
    padding 0
    overflow hidden
    color $secondary

li
    float left
    & a
        display block
        text-align center

a
    color #000000
    text-decoration none
</style>
